import styled from 'styled-components';
import { BasketPxDetailsStyled } from '../../BasketPxDetailsStyled';
import { rem } from 'polished';

export const BasketPxDetailsOV = styled(BasketPxDetailsStyled)`
    .description {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
        .titleWrapper {
            .title {
                font-size: ${({ theme }) => theme.fontSizes.h3};
            }
        }
    }

    .continue {
        .continueLabel {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
    }

    .status {
        .statusIcon {
            svg {
                top: ${rem(35)};
            }
        }

        .statusLabel {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
            line-height: ${rem(20)};
        }

        .trash {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            font-family: ${({ theme }) => theme.fonts.fontSecondary};

            svg {
                margin-bottom: ${rem(-3)};
            }
        }
    }
`;
